import commonMixin from '../mixins/_common';
import modalMixin from '../mixins/_modal';
import flashMessageMixin from './../mixins/_flash_messages';

/**
 * カスタムページ選択コンポーネント
 */
export default {
    name: 'ModalCustomPageSelecter',
    template: '#modal-custom-page-selecter-template',
    data() {
        return {
            // カスタムページ一覧
            customPages: null,
        };
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    computed: {
        // カスタムページ一覧が有るか
        hasCustomPages: function () {
            return (this.customPages !== null && this.customPages.length > 0);
        },
    },
    emits: ['selected-page'],
    methods: {
        // モーダルを開く
        openModal: async function () {
            try {
                await this.getCustomPages();
                this.open();
            } catch (e) {
                // エラーが発生した場合、フラッシュメッセージを表示
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: this.getCatchMessage(e),
                }, this.$parent);
            }
        },
        // カスタムページ一覧を取得する
        getCustomPages: async function () {
            try {
                this.$_loading();
                const response = await axios.get('/custom_page/get_page_list');
                if(response.data.status === 'OK') {
                    this.customPages = response.data.customPages;
                }
            } finally {
                this.$_unloading();
            }
        },
        // ページ選択時処理
        selectePage: function (customPage) {
            this.emitSelectedPage(customPage);
            this.close();
        },
        // 選択されたページを親に通知する
        emitSelectedPage: function (customPage) {
            this.$emit('selected-page', customPage.PageKey);
        }
    },
};
